import { Dialog, DialogProps } from "primereact/dialog";
import React from "react";
import styled from "styled-components";
import { device } from "../../constants/mediaQueries";

interface CvpDialogProps extends DialogProps {
  visible: boolean;
  headerElement?: JSX.Element;
  footerContent?: JSX.Element;
  buttonfooter?: boolean;
}

export const CvpDialog = (props: CvpDialogProps) => {
  const { headerElement, footerContent, visible, children, ...rest } = props;

  return (
    <StyledCvpDialog
      breakpoints={{ "960px": "80vw", "641px": "90vw" }}
      visible={visible}
      modal
      header={headerElement}
      footer={footerContent}
      style={{ width: "50rem" }}
      {...rest}
    >
      {children}
    </StyledCvpDialog>
  );
};

const StyledCvpDialog = styled(Dialog)`
  &.p-dialog {
    .p-dialog-header {
      padding: 2rem 1.5rem 0 1.5rem;

      @media ${device.md} {
        padding: 3rem 2rem 0 2rem;
      }
    }

    .p-dialog-title {
      font-weight: 700;
      font-size: 1rem;
      color: var(--primary-color);
    }

    .p-dialog-content {
      padding: 2rem;

      @media ${device.md} {
        padding: 2.5rem 3rem;
      }
    }

    .p-dialog-footer {
      padding: 0 1.5rem 2rem 1.5rem;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      gap: 1rem;
      flex-direction: column-reverse;

      @media ${device.md} {
        padding: 0 2rem 3rem 2rem;
        flex-direction: row;
      }
    }
  }
`;
